import React from 'react';
import { Budget, Transaction } from '../types/budget';
import { TransactionTableHeader } from './TransactionTableHeader';
import { TransactionTableRow } from './TransactionTableRow';
import { TransactionTableFooter } from './TransactionTableFooter';

type SortField = 'category' | 'responsible' | 'description' | 'destination' | 'amount';
type SortDirection = 'asc' | 'desc';

interface TransactionTableProps {
  budget: Budget;
  transactions: Transaction[];
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  onEdit: (transaction: Transaction) => void;
  onDelete: (transaction: Transaction) => void;
  onCreateInverse: (transaction: Transaction) => void;
  showActions?: boolean;
}

export const TransactionTable: React.FC<TransactionTableProps> = ({
  budget,
  transactions,
  sortField,
  sortDirection,
  onSort,
  onEdit,
  onDelete,
  onCreateInverse,
  showActions = true,
}) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full divide-y divide-slate-200 dark:divide-surface-700/50">
        <TransactionTableHeader
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
          showActions={showActions}
        />
        <tbody className="divide-y divide-slate-200 bg-white dark:divide-surface-700/50 dark:bg-surface-900">
          {transactions.map((transaction, index) => (
            <TransactionTableRow
              key={transaction.id || index}
              transaction={transaction}
              budget={budget}
              index={index}
              onEdit={onEdit}
              onDelete={onDelete}
              onCreateInverse={onCreateInverse}
              showActions={showActions}
            />
          ))}
        </tbody>
        <TransactionTableFooter transactions={transactions} budget={budget} />
      </table>
    </div>
  );
};
